import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import toast from 'components/partials/toast/toast';

import { sendFeedback } from 'api/ai-assistant/ai-assistant-api';

interface UseApiSendFeedbackArgs {
  oktaUserId: string;
  clientId: string | number;
  conversationId: string;
  messageId: string;
}

interface ApiErrorLike {
  data?: { detail?: string };
}

export const useApiSendFeedback = ({
  oktaUserId,
  clientId,
  conversationId,
  messageId,
}: UseApiSendFeedbackArgs): UseMutationResult<unknown, ApiErrorLike, unknown> =>
  useMutation<unknown, ApiErrorLike, unknown>({
    mutationFn: (data) =>
      sendFeedback({ oktaUserId, conversationId, messageId, data, clientId }),
    onSuccess: () =>
      toast.success({
        title: 'Feedback sent successfully',
      }),
    onError: (error) =>
      toast.error({
        title: 'Error sending feedback',
        message: error?.data?.detail,
      }),
  });
